import { render, staticRenderFns } from "./D103.vue?vue&type=template&id=1612a634&scoped=true"
import script from "./D103.vue?vue&type=script&lang=js"
export * from "./D103.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=1612a634&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612a634",
  null
  
)

export default component.exports